import { HorizontalSafeAreaContainer } from '../../../../components';
import { GroupOrderJoinScreen } from '../../../../screens/GroupOrderJoinScreen';

// ─────────────────────────────────────────────────────────────────────────────

export default function GroupOrderJoinRoute() {
  return (
    <HorizontalSafeAreaContainer>
      <GroupOrderJoinScreen />
    </HorizontalSafeAreaContainer>
  );
}
